import { useEffect, useRef, useState } from "react";
import StarRating from './StarRatting.js'
import { useKey } from "../customHooks/useKey.js";


 const KEY = "3edd0f8a";
export default function MovieDetails({selectedId,onClose,onAddWatchedMovie,watchedMovie}){
    const [movie,setMovie]=useState({})
    const [loader,setLoader]=useState(false)
    const [userRating , setUsrRating]=useState('')

    const countRef=useRef(0);

    useEffect(function(){
      if(userRating) countRef.current  += 1;
    },[userRating])
    
    const isWatched=watchedMovie.map((movie)=> movie.imdbID).includes(selectedId);
    const watchedUserRating=watchedMovie.find(movie=>movie.imdbID===selectedId)?.userRating;

    const {Title:title, Year:year,Poster:poster,Runtime:runtime, imdbRating,Plot:plot,Released : released, Actors:actors,Director:director, Genre:genre} =movie;

    function handleAdd(){
      const newAddWatchedMovie= {
        imdbID:selectedId,
        title,
        year,
        poster,
        imdbRating:Number(imdbRating),
        runtime:Number(runtime.split(' ').at(0)),
        userRating:userRating,
        countRatingDecision:countRef.current,
      }
      onAddWatchedMovie(newAddWatchedMovie);
    }
 
    useEffect(function() {
        async function getMovieDetails() {
            
               setLoader(true)
               const res= await fetch(
                   `https://www.omdbapi.com/?apikey=${KEY}&i=${selectedId}`
                );
                const data=await res.json();
                setMovie(data);
                setLoader(false);     
        }
        
        getMovieDetails();
    },[selectedId])

    useEffect(function (){
      if(!title) return;
        document.title=`Movie | ${title}`

        return function() {
          document.title='usePopcorn'
        }
    },[title])

        // useEffect(function(){
        //   function callBack(e){ 
        //     if(e.code === 'Backspace') {
        //       onClose();
        //      };
        //     }     
        //   document.addEventListener('keydown' , callBack);

        //   return ()=>{
        //     document.removeEventListener('keydown',callBack)
        //   }
        // },[onClose])
        useKey("Backspace",onClose)
        
    return <div className="">
        { loader? <h1 className="text-center mx-auto p-2 font-bold">Loading...</h1>:
        <>
        <header className="flex space-x-5 p-2 bg-background100 rounded-sm">
            <div className="relative">
            <button className="bg-white px-1 pb-1 rounded-full text-black text-2xl font-bold absolute left-1 top-1" onClick={onClose}>&larr;</button>
            <img src={poster} alt={`Poster of ${movie} movie`}  className="w-24 h-32"/>
            </div>
            <div className="space-y-2 text-xs ">
              <h2 className="text-sm font-bold">{title}</h2>
              <p >
                {released} &bull; {runtime}
              </p>
              <p>{genre}</p>
              <p>
                <span>⭐️</span>
                {imdbRating} IMDb rating
              </p>
            </div>
          </header>
          {!isWatched ?<div className="mt-5 bg-background100 p-3 rounded-md flex flex-col gap-5 w-1/2  mx-auto py-4">
          <StarRating maxRating={10} className="flex justify-center items-center gap-2" size={24} starContainer="flex" onsetRating={setUsrRating}/>
          {userRating > 0 && <button className="bg-primary rounded-full py-1" onClick={handleAdd} >+ Add to list</button>}
          </div>: <p className="my-5 bg-gray-700 font-mono text-center rounded-md   w-1/2  mx-auto p-2"> You are rated this movie {watchedUserRating} <span>🌟</span></p>}
        <section className="text-xs w-[90%] mx-auto mt-3 space-y-3">
            <p>
              <em>{plot}</em>
            </p>
            <p>Starring {actors}</p>
            <p>Directed by {director}</p>
          </section>
        </>}
    </div>
}